import { postDataSecurityAccessAuditExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAccessAuditExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAccessAuditExport',
	receive: true,
	request: true,
	requestHandler: postDataSecurityAccessAuditExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
